var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, HostListener, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { KtsConstructionTaskService } from '../task/construction-task.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
var KtsGanttComponent = /** @class */ (function (_super) {
    __extends(KtsGanttComponent, _super);
    function KtsGanttComponent(router, route, logger, action, message, page, service, constTaskService, colService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.constTaskService = constTaskService;
        _this.colService = colService;
        _this.visibleComp = true;
        _this.hiddenMenu = false;
        _this.ganttElements = {};
        _this.step = [];
        _this.taskItems = {};
        _this.constItems = {};
        _this.ganttData = {};
        return _this;
    }
    KtsGanttComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
    };
    KtsGanttComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('CONSTRUCTION_STEP').subscribe(function (rec) {
            var options = [];
            for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                var r = rec_1[_i];
                options.push({ code: parseInt(r.code), display: r.display });
            }
            _this.step = options;
        });
        this.DATE_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatDate']);
        this.DATETIME_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.format']);
    };
    KtsGanttComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.gantts.changes.subscribe(function (gantts) {
            gantts.map(function (gantt) {
                var step = gantt.nativeElement.getAttribute('data-step');
                _this.ganttElements[step] = new GanttElement();
                _this.ganttElements[step].element = gantt.nativeElement;
            });
        });
    };
    KtsGanttComponent.prototype.ngAfterViewChecked = function () {
        var _this = this;
        var visibleComp = $(this.ganttComp.nativeElement).is(':visible');
        if (this.visibleComp !== visibleComp) {
            this.visibleComp = visibleComp;
            if (this.visibleComp) {
                this.step.map(function (x) { return _this.setGantt(x.code); });
            }
        }
        var hiddenMenu = $('#menuPush').hasClass('pushMenuWrapper-toleft');
        if (this.hiddenMenu !== hiddenMenu) {
            this.hiddenMenu = hiddenMenu;
            window.clearTimeout(this.timeoutID2);
            this.timeoutID2 = window.setTimeout(function () {
                _this.step
                    .filter(function (x) { return _this.ganttElements[x.code].width !== _this.ganttElements[x.code].element.parentElement.offsetWidth; })
                    .map(function (x) {
                    _this.ganttElements[x.code].width = _this.ganttElements[x.code].element.parentElement.offsetWidth;
                    _this.setGantt(x.code);
                });
            }, 300);
        }
    };
    KtsGanttComponent.prototype.switchToggle = function (step) {
        var el = this.ganttElements[step];
        $(el.element.parentElement).toggle();
        el.toggle = !el.toggle;
        el.width = el.element.parentElement.offsetWidth;
        this.setGantt(step);
    };
    KtsGanttComponent.prototype.setToggle = function (flg) {
        for (var _i = 0, _a = this.step; _i < _a.length; _i++) {
            var step = _a[_i];
            var el = this.ganttElements[step.code];
            if (flg) {
                $(el.element.parentElement).show();
            }
            else {
                $(el.element.parentElement).hide();
            }
            el.toggle = flg;
            el.width = el.element.parentElement.offsetWidth;
            this.setGantt(step.code);
        }
    };
    KtsGanttComponent.prototype.setGantt = function (step) {
        var data = this.ganttData[step];
        var el = this.ganttElements[step];
        if (!el.toggle || !data || data.length === 0) {
            return;
        }
        var slideWidth = el.width - 260;
        slideWidth = slideWidth < 200 ? 200 : slideWidth;
        $(el.element).empty();
        $(el.element).ganttView({
            data: data,
            slideWidth: slideWidth,
            behavior: {
                clickable: false,
                draggable: false,
                resizable: false
            },
            yearMonthFormat: this.msgSnapshot['au.COMPONENT.KtsGanttComponent.option.yearMonthFormat']
        });
        var blocks = $(el.element).children('.ganttview').children('.ganttview-slide-container').children('.ganttview-blocks').find('.ganttview-block');
        var count = 0;
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var d = data_1[_i];
            for (var _a = 0, _b = d.series; _a < _b.length; _a++) {
                var series = _b[_a];
                // 実施日が無くても枠だけ表示する
                if (series.hidden) {
                    $(blocks[count]).hide();
                }
                count++;
            }
        }
    };
    KtsGanttComponent.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.timeoutID);
        this.timeoutID = window.setTimeout(function () {
            _this.step.map(function (x) {
                _this.ganttElements[x.code].width = _this.ganttElements[x.code].element.parentElement.offsetWidth;
                _this.setGantt(x.code);
            });
        }, 300);
    };
    KtsGanttComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsGanttComponent.prototype.onSubscribe = function (data) {
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            this.setGanttData();
            return;
        }
        data = JSOG.parse(JSON.stringify(data));
        // task_u
        if (typeof data.items[0].task_m_id !== 'undefined' && typeof data.items[0].is_complete !== 'undefined') {
            this.constItems = {};
            var items = data.items;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                if (item.construction_report && item.construction_report.length > 0) {
                    this.constTaskService.sortDatetime(item.construction_report);
                }
                this.constItems[item.task_m_id] = item;
            }
        }
        // task_m
        if (typeof data.items[0].project_m_id !== 'undefined' && typeof data.items[0].template_type !== 'undefined') {
            this.taskItems = {};
            var items = data.items;
            for (var _a = 0, items_2 = items; _a < items_2.length; _a++) {
                var item = items_2[_a];
                if (typeof this.taskItems[item.step] === 'undefined') {
                    this.taskItems[item.step] = [];
                }
                this.taskItems[item.step].push(item);
            }
        }
        this.setGanttData();
    };
    KtsGanttComponent.prototype.setGanttData = function () {
        var _this = this;
        var now = moment().format(this.DATE_DELIMITER_SLASH);
        this.ganttData = {};
        for (var _i = 0, _a = Object.keys(this.taskItems); _i < _a.length; _i++) {
            var key = _a[_i];
            this.ganttData[key] = [];
            this.ganttElements[key].minDate = null;
            for (var _b = 0, _c = this.taskItems[key]; _b < _c.length; _b++) {
                var item = _c[_b];
                var task = this.constItems[item.id];
                var series = [];
                if (typeof task === 'undefined') {
                    series.push(this.getSeriesHidden());
                    this.ganttData[key].push({ id: item.id, name: item.name, series: series });
                    continue;
                }
                if (!task.necessity) {
                    continue;
                }
                if (item.template_type === "onsite" /* onsite */ || item.template_type === "onsite_notime" /* onsite_notime */ || item.template_type === "construction" /* construction */) {
                    for (var _d = 0, _e = task.construction_report; _d < _e.length; _d++) {
                        var report = _e[_d];
                        var plan = this.getSeriesDate(key, "plan" /* plan */, report.visiting_scheduled_date, report.leaving_scheduled_date, this.checkPlanDelay(report.leaving_scheduled_date, report.leaving_actual_date));
                        if (plan !== null) {
                            series.push(plan);
                        }
                        var act = this.getSeriesDate(key, "act" /* act */, report.visiting_actual_date, report.leaving_actual_date, this.checkCompleteDelay(report.visiting_scheduled_date, report.leaving_scheduled_date, report.visiting_actual_date, report.leaving_actual_date));
                        if (act !== null) {
                            series.push(act);
                        }
                        else {
                            series.push(this.getSeriesHidden());
                        }
                    }
                    if (task.construction_report.length === 0) {
                        series.push(this.getSeriesHidden());
                    }
                }
                else {
                    var plan = this.getSeriesDate(key, "plan" /* plan */, task.plan_date, null, this.checkPlanDelay(task.plan_date, task.act_date));
                    if (plan !== null) {
                        series.push(plan);
                    }
                    var act = this.getSeriesDate(key, "act" /* act */, task.act_date, null, this.checkCompleteDelay(task.plan_date, null, task.act_date, null));
                    if (act !== null) {
                        series.push(act);
                    }
                    else {
                        series.push(this.getSeriesHidden());
                    }
                }
                if (series.length === 0) {
                    continue;
                }
                this.ganttData[key].push({ id: item.id, name: item.name, series: series });
            }
            if (!this.ganttElements[key].minDate) {
                this.ganttElements[key].minDate = now;
            }
            var minDate = this.ganttElements[key].minDate;
            for (var _f = 0, _g = this.ganttData[key]; _f < _g.length; _f++) {
                var data = _g[_f];
                for (var _h = 0, _j = data.series; _h < _j.length; _h++) {
                    var series = _j[_h];
                    if (series.hidden) {
                        series.start = minDate;
                        series.end = minDate;
                    }
                }
            }
        }
        this.step.map(function (x) { return _this.setGantt(x.code); });
    };
    KtsGanttComponent.prototype.getSeriesHidden = function () {
        return {
            name: this.msgSnapshot['au.COMPONENT.KtsGanttComponent.label.act'],
            start: null,
            end: null,
            color: "#4fd028" /* act */,
            hidden: true
        };
    };
    KtsGanttComponent.prototype.getSeriesDate = function (key, type, start, end, delay) {
        var name = this.msgSnapshot['au.COMPONENT.KtsGanttComponent.label.plan'];
        var color = (delay ? "#e62db5" /* planDelay */ : "#005eaa" /* plan */);
        if (type === "act" /* act */) {
            name = this.msgSnapshot['au.COMPONENT.KtsGanttComponent.label.act'];
            color = (delay ? "#e65e2d" /* completeDelay */ : "#4fd028" /* act */);
        }
        var sDate = null;
        if (this.colService.checkVal(start)) {
            sDate = moment(start, this.DATETIME_DELIMITER_SLASH).format(this.DATE_DELIMITER_SLASH);
        }
        var eDate = null;
        if (this.colService.checkVal(end)) {
            eDate = moment(end, this.DATETIME_DELIMITER_SLASH).format(this.DATE_DELIMITER_SLASH);
        }
        if (sDate && eDate) {
            this.checkMinDate(key, sDate);
            return { name: name, start: sDate, end: eDate, color: color, hidden: false };
        }
        else if (sDate && !eDate) {
            this.checkMinDate(key, sDate);
            return { name: name, start: sDate, end: sDate, color: color, hidden: false };
        }
        else if (!sDate && eDate) {
            this.checkMinDate(key, eDate);
            return { name: name, start: eDate, end: eDate, color: color, hidden: false };
        }
        return null;
    };
    // 予定超過
    KtsGanttComponent.prototype.checkPlanDelay = function (plan, act) {
        if (plan && !act) {
            var planDate = moment(plan, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            var now = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
            if (planDate.isBefore(now)) {
                return true;
            }
        }
        return false;
    };
    // 完了超過
    KtsGanttComponent.prototype.checkCompleteDelay = function (planStart, planEnd, actStart, actEnd) {
        if (planStart && actStart) {
            var planDate = moment(planStart, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            var actDate = moment(actStart, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            if (planDate.isBefore(actDate)) {
                return true;
            }
        }
        if (planEnd && actEnd) {
            var planDate = moment(planEnd, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            var actDate = moment(actEnd, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            if (planDate.isBefore(actDate)) {
                return true;
            }
        }
        return false;
    };
    KtsGanttComponent.prototype.checkMinDate = function (key, date) {
        var el = this.ganttElements[key];
        var d1 = moment(el.minDate, this.DATE_DELIMITER_SLASH);
        var d2 = moment(date, this.DATE_DELIMITER_SLASH);
        if (!el.minDate || d1.isAfter(d2)) {
            el.minDate = date;
        }
    };
    KtsGanttComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
        }
    };
    KtsGanttComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'open') {
            this.setToggle(true);
        }
        else if (e2 === 'close') {
            this.setToggle(false);
        }
    };
    KtsGanttComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-gantt',
                    template: "<div id=\"{{ componentName }}\" #ganttComp>\n  <div class=\"-txtalnright\">\n    <pre class=\"tag tag-cyan\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.plan'] }}</pre>\n    <pre class=\"tag tag-lime\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.act'] }}</pre>\n    <pre class=\"tag tag-pink\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.planDelay'] }}</pre>\n    <pre class=\"tag tag-orange\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.completeDelay'] }}</pre>\n    <span class=\"-mr-2\"></span>\n    <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'open', '')\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.openAll'] }}</a>\n    <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'close', '')\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.closeAll'] }}</a>\n  </div>\n  <div *ngFor=\"let st of step; let stepIndex = index;\" class=\"row\" [class.-mb-1]=\"stepIndex < step.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <p class=\"filter_trigger\">\n          <span [class.open]=\"ganttElements[st.code]?.toggle\" (click)=\"switchToggle(st.code)\">STEP{{ st.code }}: {{ st.display }}</span>\n        </p>\n        <div class=\"filter_property_toggle -mb-2 ganttChart\" [style.overflow-x]=\"ganttData[st.code]?.length > 0 ? 'auto' : 'none'\">\n          <p *ngIf=\"!ganttData[st.code] || ganttData[st.code]?.length === 0\" class=\"-mt-1\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.noDate'] }}</p>\n          <div [attr.data-step]=\"st.code\" style=\"min-width: 250px;\" #gantt></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsGanttComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: KtsConstructionTaskService },
        { type: ColumnService }
    ]; };
    KtsGanttComponent.propDecorators = {
        ganttComp: [{ type: ViewChild, args: ['ganttComp',] }],
        gantts: [{ type: ViewChildren, args: ['gantt',] }],
        onResize: [{ type: HostListener, args: ['window:resize',] }]
    };
    return KtsGanttComponent;
}(ContentBaseComponent));
export { KtsGanttComponent };
var GanttElement = /** @class */ (function () {
    function GanttElement() {
        this.toggle = false;
        this.width = 0;
    }
    return GanttElement;
}());
var GanttData = /** @class */ (function () {
    function GanttData() {
        this.series = [];
    }
    return GanttData;
}());
var GanttSeries = /** @class */ (function () {
    function GanttSeries() {
    }
    return GanttSeries;
}());
//# sourceMappingURL=gantt.component.js.map